//  IMPORTANT:
//  This file is generated. Your changes will be lost.
//  Source Table: [dbo].[LakeClarityTrackerCategory]

import { LookupTableEntry } from "src/app/shared/models/lookup-table-entry";
import { SelectDropdownOption } from "src/app/shared/components/forms/form-field/form-field.component"

export enum LakeClarityTrackerCategoryEnum {
  AtmosphericDeposition = 1,
  StreamChannelErosion = 2,
  UrbanUplands = 3,
  ForestUplands = 4,
  WaterClarity = 5,
}

export const LakeClarityTrackerCategories: LookupTableEntry[]  = [
  { Name: "AtmosphericDeposition", DisplayName: "Atmospheric Deposition", Value: 1, SortOrder: 30 },
  { Name: "StreamChannelErosion", DisplayName: "Stream Channel Erosion", Value: 2, SortOrder: 40 },
  { Name: "UrbanUplands", DisplayName: "Urban Uplands", Value: 3, SortOrder: 10 },
  { Name: "ForestUplands", DisplayName: "Forest Uplands", Value: 4, SortOrder: 20 },
  { Name: "WaterClarity", DisplayName: "Water Clarity", Value: 5, SortOrder: 50 },
];
export const LakeClarityTrackerCategoriesAsSelectDropdownOptions = LakeClarityTrackerCategories.map((x) => ({ Value: x.Value, Label: x.DisplayName, SortOrder: x.SortOrder } as SelectDropdownOption));

